import React, {useEffect, useState, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import searchIcon from '../../assets/search-glass.png';
import PageBase from "../../components/PageBase";
import Datatable from "../../components/Datatable";
import * as programActions from "../../redux/Program/actions";
import Filters from "../../components/Filters";
import availableFilters from './availableFilters.js';
import columns from './column.js';
import Icon from 'react-web-vector-icons';
import moment from "moment/moment.js";
import LoadingPanel from "../../components/LoadingPanel";
import constants from "../../utils/constants.js";
import usePersistentFilters from '../../hooks/usePersistentFilters';
import useColumnFilters from '../../hooks/useColumnFilters.js';
import { getDisplayFields, getDefaultFields } from '../../utils/fields/programs.js';
import ListManager from '../../components/ListManager';
import {createColumnConfigs} from '../../utils/fieldUtils.js';

import './Programs.scss';
import { use } from 'react';

const Programs = props => {
	const [loading, setLoading] = useState(true);
	const [filterResetKey, setFilterResetKey] = useState(0);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const programs = useSelector(state => state.program).programs;
	const lastUpdated = useSelector(state => state.program).lastUpdated;
	const [listColumns, setListColumns] = useState([]);
	const entityType = `${constants.DISPLAY_ENTITIES.PROGRAMS}`;
	const fieldsToUse = useMemo(() => {
		return createColumnConfigs(getDisplayFields(listColumns.length === 0,listColumns))
	}, [listColumns]);

	const {
		search,
		setSearch,
		selectedFilters,
		setSelectedFilters,
		clearFilters: clearPersistentFilters
	} = usePersistentFilters('programs', '', []);
	const searchedData = useMemo(() => {
	if (!programs) return [];
	if (!search) return programs;
	const lowerSearch = search.toLowerCase();
	return programs?.filter(f => f.Name.toLowerCase().includes(lowerSearch));
	}, [programs, search]);

	const {
		filters,
		sortBy,
		sortOrder,
		filteredData,
		handleFilterChange,
		resetWith,
		updateData,
		uniqueValuesByColumn,
		filterOrder
	} = useColumnFilters({
		data: searchedData || [],
		columns: fieldsToUse,
		storageKey: `programs`,
		initialState: {}
	});
	useEffect(() => {
		if(selectedFilters.length > 0) return;
		const load = async () => {
			await dispatch(programActions.loadPrograms([]));
			setLoading(false);
		};
		load();
	}, []);

	useEffect(() => {
		if(selectedFilters.length === 0) return;
		const load = async () => {
			setLoading(true);
			await dispatch(programActions.loadPrograms(selectedFilters));
			setLoading(false);
		};
		load();
	}, [selectedFilters]);

	useEffect(() => {
		updateData(programs);
	}, [programs]);
	if(loading || programs == null) {
		return (
			<PageBase title="Programs" removeMargins>
				<LoadingPanel />
			</PageBase>
		)
	}

	const onRowClick = async (row, index) => {
		console.log(index, row.Id);
		navigate(`/program/${row.Id}`);
	};

	const updateFilter = (value) => {
		setSearch(value.toLowerCase());
	};


	const addFilter = filter => {
		const index = selectedFilters.findIndex(f => f.name === filter.name);

		if(index < 0) {
			setSelectedFilters([...selectedFilters, filter]);
		}
		else {
			const updated = [...selectedFilters];
			updated[index] = filter;
			setSelectedFilters(updated);
		}
	};

	const removeFilter = (filterToRemove) => {
		const filters = selectedFilters.filter(f => f.name !== filterToRemove.name);
		setSelectedFilters(filters);
	};

	const onClearFilters = () => {
		clearPersistentFilters();
	};

	const filteredPrograms = programs
		.filter(f => f.Name.toLowerCase().indexOf(search) > -1)
		.sort((a, b) =>  sortOrder === "asc" ? (a[sortBy] || '').localeCompare((b[sortBy] || '')) : (b[sortBy] || '').localeCompare((a[sortBy] || '')));

	return (
		<PageBase title="Programs" removeMargins>
			<div className="programs-header">

				<div className="programs-search-box">
					<img src={searchIcon} style={{padding: '0 10px'}} />
					<input className="programs-search-input" type="text" value={search} onChange={e => updateFilter(e.target.value)} placeholder="Search Programs..." />
				</div>
				<Filters availableFilters={availableFilters} clearFilters={onClearFilters} selectedFilters={selectedFilters} onAddFilter={addFilter} onRemoveFilter={removeFilter} />
				<div style={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingRight: 20 }}>
					<ListManager
						entityType={entityType}
						displayFields={getDisplayFields()}
						defaultFields={getDisplayFields(true).map(f => f.field)}
						onColumnsChange={setListColumns}
					/>
				</div>
			</div>

			<div style={{margin: '0 30px'}}>
				<p style={{ color: '#062229', fontWeight: 700, fontSize: 14 }}>Found {filteredData?.length || 0} Programs</p>
			</div>

			<div style={{margin: '0 30px'}}>
				<Datatable 
					gridHeight="calc(100vh - 185px)"
					columns={fieldsToUse}
					data={filteredData}
					key={filterResetKey}
					//onSort={updateSort}
					sortBy={sortBy}
					sortOrder={sortOrder}
					onRowClick={onRowClick}
					filters={filters}
					onFilterChange={handleFilterChange}
					filterOrder={filterOrder}
					uniqueValuesByColumn={uniqueValuesByColumn}
					allData={programs}
				/>
			</div>
		</PageBase>
	)
};

export default Programs;
